import { combineForms } from 'react-redux-form'

const contact = combineForms(
  {
    form: {
      name: '',
      email: '',
      subject: '',
      message: ''
    }
  },
  'contact'
)

export { contact as default }
